import { useLocation } from 'react-router-dom';
import { decodeHash } from '../api/Common';

const HashState = () => {
  const location = useLocation(); // Get the current location from React Router
  return decodeHash(location.hash.substring(1));
};

export default HashState;
